import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, Layout } from 'antd';
import { useLocation } from 'react-router-dom';
import NoteRules from '../components/preferences/NoteRules';
import NoteTemplates from '../components/preferences/NoteTemplates';

const { Content } = Layout;

const Preferences = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState('note-rules');

  // Handle hash-based navigation using React Router
  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash === 'templates') {
      setActiveKey('templates');
    } else if (hash === 'note-rules') {
      setActiveKey('note-rules');
    }
  }, [location.hash]);

  // Update URL hash when tab changes
  const handleTabChange = (key) => {
    setActiveKey(key);
    const hash = key === 'templates' ? 'templates' : 'note-rules';
    window.location.hash = hash;
  };

  const items = [
    {
      key: 'note-rules',
      label: (
        <span style={{ 
          fontSize: '16px', 
          fontWeight: '600',
          color: 'rgba(0, 0, 0, 0.55)'  // Slightly lighter than default
        }}>
          {t('note_rules.title')}
        </span>
      ),
      children: <NoteRules />,
    },
    {
      key: 'templates',
      label: (
        <span style={{ 
          fontSize: '16px', 
          fontWeight: '600',
          color: 'rgba(0, 0, 0, 0.55)'  // Slightly lighter than default
        }}>
                          {t('note_templates.title')}
        </span>
      ),
      children: <NoteTemplates />,
    },
  ];

  return (
    <Content className="page">
      <Tabs
        activeKey={activeKey}
        onChange={handleTabChange}
        items={items}
        style={{ backgroundColor: 'white', padding: '24px', borderRadius: '8px' }}
      />
    </Content>
  );
};

export default Preferences; 